export default __webpack_public_path__ + "static/media/reminder-success.dd7694cd.gif";